<script lang="ts">
    import type {LocalizeFunction} from '../../../svelte/types';
    import {getContext} from 'svelte';
    import {LOCALIZE_KEY, pipe} from '../../../svelte/utils';
    import locFilter from '../../filters/loc';
    import type {SelectableCatalogue} from './catalogue-selection-modal.component';

    export let option: SelectableCatalogue;

    const localize: LocalizeFunction = getContext(LOCALIZE_KEY);
</script>

<template>
    {localize(/* @kp-localization login.selectDepartment.GoTo */ 'login.selectDepartment.GoTo')}
    {pipe(option.department, locFilter())}
    <small>({option.url})</small>
</template>